export default [
  { value: "Fair Market", label: "Fair Market" },
  { value: "REO", label: "REO" },
  { value: "Short Sale", label: "Short Sale" },
];
